import 'dayjs/locale/es-mx'
import { Dayjs } from 'dayjs'

const es_mx = {
  calendar: {
    sameDay: function (now: Dayjs) {
      return now.format('[hoy a la' + (now.hour() !== 1 ? 's' : '') + '] LT')
    },
    nextDay: function (now: Dayjs) {
      return now.format('[mañana a la' + (now.hour() !== 1 ? 's' : '') + '] LT')
    },
    nextWeek: function (now: Dayjs) {
      return now.format('dddd [a la' + (now.hour() !== 1 ? 's' : '') + '] LT')
    },
    lastDay: function (now: Dayjs) {
      return now.format('[ayer a la' + (now.hour() !== 1 ? 's' : '') + '] LT')
    },
    lastWeek: function (now: Dayjs) {
      return now.format('[el] dddd [pasado a la' + (now.hour() !== 1 ? 's' : '') + '] LT')
    },
    sameElse: 'L'
  }
}

export default es_mx
